'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _store = require('store2');

var _store2 = _interopRequireDefault(_store);

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecentlyViewedProductsStorage = function () {
  function RecentlyViewedProductsStorage() {
    (0, _classCallCheck3.default)(this, RecentlyViewedProductsStorage);

    this.version = 'v1';
    this.storage = _store2.default;
    this.productsToStoreInMemory = 10;
    this.keys = {
      recentProducts: 'BAO-recentProducts-' + this.version
    };
  }

  (0, _createClass3.default)(RecentlyViewedProductsStorage, [{
    key: 'getHandles',
    value: function getHandles() {
      return this.storage.get(this.keys.recentProducts, []);
    }
  }, {
    key: 'setHandles',
    value: function setHandles(handles) {
      this.storage.set(this.keys.recentProducts, handles);
    }
  }, {
    key: 'setHandle',
    value: function setHandle(handle) {
      var recentProducts = this.getHandles();

      if (recentProducts && recentProducts.includes(handle)) {
        var handleIndex = recentProducts.indexOf(handle);
        recentProducts.splice(handleIndex, 1);
      }

      recentProducts.unshift(handle);

      if (recentProducts.length > this.productsToStoreInMemory) {
        recentProducts.pop();
      }

      this.setHandles(recentProducts);
    }
  }, {
    key: 'record',
    value: function record() {
      // If we are on a product page.
      if (window.location.pathname.includes('/products/')) {
        var handle = (0, _functional.getElement)('[data-product-handle]').dataset.productHandle;

        this.setHandle(handle);
      }
    }
  }]);
  return RecentlyViewedProductsStorage;
}();

exports.default = RecentlyViewedProductsStorage;